import qs from 'qs'

import get from 'lodash/get'

import { FRONTEND_URL } from 'Config/app'

function getLocationHashParams(location) {
  return qs.parse(get(location, 'hash', '').replace('#', ''))
}

function getLocationSearchParams(location) {
  return qs.parse(get(location, 'search', '').replace('?', ''))
}

function getFullLocation(location) {
  return `${get(location, 'pathname', '/')}${get(location, 'search', '')}${get(
    location,
    'hash',
    '',
  )}`
}

function navigateBackToApp() {
  const { backTo } = getLocationSearchParams(window.location)

  window.location.href = backTo ? decodeURIComponent(backTo) : FRONTEND_URL
}

export default {
  getLocationHashParams,
  getLocationSearchParams,
  getFullLocation,
  navigateBackToApp,
}
